export default "__VITE_ASSET__84feb80f__"